
import React, { Component } from 'react';
import { InfoCircleOutlined, EllipsisOutlined } from '@ant-design/icons';
import { SET_ASSOCIATE_DIALOG_SHOW, SCHEDULE_show_detail, Attention_DIALOG_SHOW, Attention_DIALOG_HIDE, Attention_Scene, SET_Emergency_DIALOG_HIDE, SET_Emergency_DIALOG_SHOW, SCHEDULE_show_setGroup} from "../../../const/infoConst"
import { Select,Switch } from 'antd';
import PubSub from 'pubsub-js'
import './scheduleManagePage.less';
import btn_add from "../../../imgs/btn/btn_add.png";
import scene from "../../../imgs/item/scene.png";
import getway from "../../../imgs/item/getway.png";
import wifi_4 from "../../../imgs/mesh/wifi_4.png";
import diandian from "../../../imgs/btn/diandian.png";
import schedule from "../../../imgs/item/schedule.png";
import groupImg from "../../../imgs/item/group.png";
import arrow_right from "../../../imgs/btn/arrow_right.png";
import { getScheduleShowInfo,addNewSchedule,editEditSchedule, delScheduleInfo, getEmergencyInfo, getEmergencyDetailStr, deleteEmergencyInfo, judgeEmergencyExist } from '../../../utils/scheduleUtils';
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';

let delSceneId=0;
export default class ScheduleManagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectLeft: true,

            //普通定时
            weeks: [],
            selectId:-1,

            //应急电源定时
            manage1_switch: false,
            m1_time: "Start Time: 10:00",  //日程
            m1_week: "Schedule Date: Monday",
            m1_repet: "Repeat: 1 Week",

            manage2_switch: false,
            m2_time: "Start Time: 10:00",  //日程
            m2_week: "Schedule Date: Monday",
            m2_repet: "Repeat: 1 Week",

            manage3_switch: false,
            m3_time: "Start Time: 10:00",  //日程
            m3_week: "Schedule Date: Monday",
            m3_repet: "Repeat: 1 Week",
        };
    }

    componentDidMount() {
        this.updateScheduleUI();
        //存储新schedule后更新ui
        PubSub.subscribe("changeMeshUpdateUI", (msg, index) => {
            this.updateScheduleUI();
        })
        PubSub.subscribe(Attention_DIALOG_HIDE, (msg, index) => {
            if(index==Attention_Scene && delSceneId==SPGet("delete_scene_id")){
                delScheduleInfo();
                this.setState({ 
                    selectId:-1,
                });
            }  
        })
        //应急电源定时
        PubSub.subscribe(SET_Emergency_DIALOG_HIDE, (msg, index) => {
            this.updateEmergencySchedule();
        })
    }

    //更新当前界面定时UI
    updateScheduleUI() {
        let info= getScheduleShowInfo();
        this.setState({ 
            weeks: info
        });
    }

    // 标签选择
    showLeftUI() {
        this.setState({
            selectLeft: true,
        });
        this.props.onDataToParent("");
    }
    showRightUI() {
        this.setState({
            selectLeft: false,
        });
        this.props.onDataToParent("");
        this.updateEmergencySchedule();
    }

    //----------------------------------- 普通定时--------------------------------------------
    //新建scene
    sendDataToParent_sche(){
        addNewSchedule();
        this.props.onDataToParent(SCHEDULE_show_detail);
        PubSub.publish("update_scene_data_ui",'');
    };

    //week点击事件(显示edit、delete按钮)
    itemBtnClick=(mid)=>{
        meshLog('mid', mid);
        this.setState({ 
           selectId:mid
        });
    }
    //编辑
    editBtnClick=()=>{
        editEditSchedule(this.state.selectId);
        this.setState({ 
           selectId:-1,
        });
        this.props.onDataToParent(SCHEDULE_show_detail);
        PubSub.publish("update_scene_data_ui",'');
    }
    //删除
    delBtnClick=()=>{
        this.setState({ 
           selectId:-1,
        });
        delSceneId=this.state.selectId;
        editEditSchedule(delSceneId);
        SPSet("delete_scene_id", delSceneId);
        PubSub.publish(Attention_DIALOG_SHOW,Attention_Scene)
    }
    //热力图
    showSetAssociateDialog(){
        PubSub.publish(SET_ASSOCIATE_DIALOG_SHOW,'')
    }

    //----------------------------------- 应急电源定时--------------------------------------------
    //更新应急电源日程状态
    updateEmergencySchedule() {
        judgeEmergencyExist();

        //manage1_switch
        let sche1 = getEmergencyInfo(1);
        let isOn1=!sche1.isAdd;
        meshLog('wjk sche1', sche1);
        this.setState({
            manage1_switch: isOn1,
        });
        if(isOn1){
            this.setState({
                m1_time: getEmergencyDetailStr(sche1,"time"),
                m1_week: getEmergencyDetailStr(sche1,"week"),
                m1_repet: getEmergencyDetailStr(sche1,"repet"),
            });
        }

        //manage2_switch
        let sche2 = getEmergencyInfo(2);
        let isOn2=!sche2.isAdd;
        meshLog('wjk sche2', sche2);
        this.setState({
            manage2_switch: isOn2,
        });
        if(isOn2){
            this.setState({
                m2_time: getEmergencyDetailStr(sche2,"time"),
                m2_week: getEmergencyDetailStr(sche2,"week"),
                m2_repet: getEmergencyDetailStr(sche2,"repet"),
            });
        }

        //manage3_switch
        let sche3 = getEmergencyInfo(3);
        let isOn3=!sche3.isAdd;
        meshLog('wjk sche3', sche3);
        this.setState({
            manage3_switch: isOn3,
        });
        if(isOn3){
            this.setState({
                m3_time: getEmergencyDetailStr(sche3,"time"),
                m3_week: getEmergencyDetailStr(sche3,"week"),
                m3_repet: getEmergencyDetailStr(sche3,"repet"),
            });
        }        
    }

    //switch开关
    manage1Switch = (checked) => {
        meshLog('wjk checked1', checked);
        SPSet("emergencyNmber", '1');
        if (checked) {
            this.setState({
                manage1_switch: true,
            });
            PubSub.publish(SET_Emergency_DIALOG_SHOW,"")
        } else {
            this.setState({
                manage1_switch: false,
            });
            deleteEmergencyInfo();
        }
        this.props.onDataToParent("");
    }
    manage2Switch = (checked) => {
        meshLog('wjk checked2', checked);
        SPSet("emergencyNmber", '2');
        if (checked) {
            this.setState({
                manage2_switch: true,
            });
            PubSub.publish(SET_Emergency_DIALOG_SHOW,"")
        } else {
            this.setState({
                manage2_switch: false,
            });
            deleteEmergencyInfo();
        }
        this.props.onDataToParent("");
    }
    manage3Switch = (checked) => {
        meshLog('wjk checked3', checked);
        SPSet("emergencyNmber", '3');
        if (checked) {
            this.setState({
                manage3_switch: true,
            });
            PubSub.publish(SET_Emergency_DIALOG_SHOW,"")
        } else {
            this.setState({
                manage3_switch: false,
            });
            deleteEmergencyInfo();
        }
        this.props.onDataToParent("");
    }
    manage1BtnClick(){
        SPSet("emergencyNmber", '1');
        this.props.onDataToParent(SCHEDULE_show_setGroup);
        PubSub.publish("update_emergency_Set_dialog","")
    }
    manage2BtnClick(){
        SPSet("emergencyNmber", '2');
        this.props.onDataToParent(SCHEDULE_show_setGroup);
        PubSub.publish("update_emergency_Set_dialog","")
    }
    manage3BtnClick(){
        SPSet("emergencyNmber", '3');
        this.props.onDataToParent(SCHEDULE_show_setGroup);
        PubSub.publish("update_emergency_Set_dialog","")
    }


    render() {
        const { selectLeft,manage1_switch, manage2_switch, manage3_switch, 
            m1_time, m1_week, m1_repet, m2_time, m2_week, m2_repet, m3_time, m3_week, m3_repet,   } = this.state;
        return (
            <div className="schedule-management-container">
                {/* 标题行 */}
                <div className="header-row">
                    <span>Schedules</span>
                    {/* <InfoCircleOutlined className="header-icon" /> */}
                </div>

                {/* 标签选择 */}
                <div className="schedule_switch">
                    <span className="item1Btn" style={{ backgroundColor: selectLeft ? "#0B47BE" : "#ffffff", color: selectLeft ? "#ffffff" : "#000000" }} onClick={() => { this.showLeftUI() }}>Sensor Control</span>
                    <span className="item2Btn" style={{ backgroundColor: selectLeft ? "#ffffff" : "#0B47BE", color: selectLeft ? "#000000" : "#ffffff" }} onClick={() => { this.showRightUI() }}>Emergency Driver</span>
                </div>

                {/* 普通定时------------------------------------------------------------------------------- */}
                <div className='sche_left' style={{display: selectLeft ?"flex":"none"}}>
                    {/* Gateway */}
                    <div className="gateway_row" onClick={() => { this.showSetAssociateDialog() }}>
                        <div className="row_title">
                            <img src={getway}/>
                            <span>Gateway Device</span>
                        </div>
                            
                        <div className="row_icon">
                            <img src={wifi_4}/>
                            <EllipsisOutlined className='tips'/>
                        </div>
                    </div>

                    {/* 创建 */}
                    <div className="scene_row">
                        <div className="row_title">
                            <img src={scene}/>
                            <span>Create Scene</span>
                        </div>
                                
                        <div className="row_icon">
                            <img src={btn_add} onClick={this.sendDataToParent_sche.bind(this)}/>
                        </div>
                    </div>
                    {/* 定时列表 */}
                    <div className="week_list">
                        {this.state.weeks.map((week) => (
                            <div className='week_item' key={week.id}>
                                <div className="week_info">
                                    <span className='title'>{week.name}</span>
                                    <span>{week.time}</span>
                                    <span>{week.quest}</span>
                                    <span>{week.group}</span>
                                    <span>{week.week}</span>
                                </div>
                                <img className="week_btn" src={diandian} onClick={() => {this.itemBtnClick(week.id)}}/>
                                <div className='eidt_info' style={{display:this.state.selectId==week.id?"flex":"none"}}>
                                    <span className='edit1' onClick={() => {this.editBtnClick()}}>Edit</span>
                                    <span className='edit2' onClick={() => {this.delBtnClick()}}>Delete</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 应急电源定时------------------------------------------------------------------------------- */}
                <div className='sche_right' style={{display: selectLeft ?"none":"flex"}}>
                    {/* Schedule 部分 */}
                    <div className="sche_section">
                        <div className="sche_header">
                            <div className="sche_title">
                                <img className='icon' src={schedule} />
                                <span>Schedule Management</span>
                            </div>
                            {/* <img className="arrow-icon" src={arrow_right}/> */}
                        </div>
                    </div>

                    <div className="manage_item1">
                        <div className="item-header">
                            <div className="item-title">
                                <span className='tips1'>Manual Test</span>
                                <span className='tips2'>Discharge Duration: 15s</span>
                            </div>
                            <Switch checked={manage1_switch} defaultChecked={false} onChange={this.manage1Switch} />
                        </div>
                        <div className="item-header" style={{ display: manage1_switch ? "flex" : "none" }} >
                            <div className="item-title">
                                <span className='tips2'>{m1_time}</span>
                                <span className='tips2'>{m1_week}</span>
                                <span className='tips2'>{m1_repet}</span>
                            </div>
                        </div>
                        {/* 选组*/}
                        <div className="em_item_header" style={{ display: manage1_switch ? "flex" : "none" }} onClick={() => { this.manage1BtnClick() }}>
                            <div className="item_title">
                                <img src={groupImg} />
                                <span>Associated Group</span>
                            </div>
                            <img className='arrowBtn' src={arrow_right} />
                        </div>
                    </div>

                    <div className="manage_item2">
                        <div className="item-header">
                            <div className="item-title">
                                <span className='tips1'>Monthly Test</span>
                                <span className='tips2'>Discharge Duration: 30s</span>
                            </div>
                            <Switch checked={manage2_switch} defaultChecked={false} onChange={this.manage2Switch} />
                        </div>
                        <div className="item-header" style={{ display: manage2_switch ? "flex" : "none" }} >
                            <div className="item-title">
                                <span className='tips2'>{m2_time}</span>
                                <span className='tips2'>{m2_week}</span>
                                <span className='tips2'>{m2_repet}</span>
                            </div>
                        </div>
                        {/* 选组*/}
                        <div className="em_item_header" style={{ display: manage2_switch ? "flex" : "none" }} onClick={() => { this.manage2BtnClick() }}>
                            <div className="item_title">
                                <img src={groupImg} />
                                <span>Associated Group</span>
                            </div>
                            <img className='arrowBtn' src={arrow_right} />
                        </div>
                    </div>

                    <div className="manage_item3">
                        <div className="item-header">
                            <div className="item-title">
                                <span className='tips1'>Annual Test</span>
                                <span className='tips2'>Discharge Duration: ≥90min</span>
                            </div>
                            <Switch checked={manage3_switch} defaultChecked={false} onChange={this.manage3Switch} />
                        </div>
                        <div className="item-header" style={{ display: manage3_switch ? "flex" : "none" }} >
                            <div className="item-title">
                                <span className='tips2'>{m3_time}</span>
                                <span className='tips2'>{m3_week}</span>
                                <span className='tips2'>{m3_repet}</span>
                            </div>
                        </div>
                        {/* 选组*/}
                        <div className="em_item_header" style={{ display: manage3_switch ? "flex" : "none" }} onClick={() => { this.manage3BtnClick() }}>
                            <div className="item_title">
                                <img src={groupImg} />
                                <span>Associated Group</span>
                            </div>
                            <img className='arrowBtn' src={arrow_right} />
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}
